import { render, staticRenderFns } from "./AnnouncementSave.vue?vue&type=template&id=79ebc71a"
import script from "./AnnouncementSave.vue?vue&type=script&lang=js"
export * from "./AnnouncementSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports